import { makeStyles } from '@material-ui/styles';
import { StyleLoader, ThemeLoader } from '@sightworks/theme';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import React from 'react';
import DownloadProps from './props';

type FileSizeProps = { fileSize: number };

const FileSize = ({ fileSize }: FileSizeProps) => {
	let suffix = 'B';
	if (fileSize > 1000) {
		suffix = 'kB';
		fileSize /= 1000;
	}
	if (fileSize > 800) {
		suffix = 'MB';
		fileSize /= 1000;
	}

	if (suffix == 'kB' || suffix == 'B') return `${Math.round(fileSize)}${suffix}`;
	const v = fileSize.toFixed(1);
	if (v.endsWith('.0')) return fileSize.toFixed(0) + suffix;
	return v + suffix;
};

const DownloadBlock = (props: DownloadProps, ref: React.Ref<any>) => {
	const { iconPosition, icon, variant, color, size, classes, file, title, content, textVariant } = props;
	const optionalProps: { endIcon?: JSX.Element, startIcon?: JSX.Element } = {};
	const pos: keyof typeof optionalProps = iconPosition === 'after' ? 'endIcon' : 'startIcon';
	const iconEl = (() => <Icon>{icon || 'description'}</Icon>)();

	optionalProps[pos] = iconEl;

	return (
		<Button
			variant={variant}
			color={color}
			size={size}
			className={classes.downloadButton}
			href={file}
			target="_blank"
			{...optionalProps}
		>
			{title}
		</Button>
	);
};

const Styles = makeStyles(theme => ({
	root: {},
	iconArea: {},
	downloadButton: {},
	downloadIcon: {},
	downloadType: {},
	infoArea: {},
	title: {},
	summary: {},
	size: {},
}));

export default ThemeLoader(StyleLoader(DownloadBlock, Styles));
